import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
//primeReact
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { TieredMenu } from "primereact/tieredmenu";
import { BreadCrumb } from "primereact/breadcrumb";
import { ToggleButton } from "primereact/togglebutton";
import { Skeleton } from "primereact/skeleton";
//components
import CreditCard from "./CreditCard";
import Panel from "../../components/panel/panel";
import NumberInput from "../../components/input/NumberInput";
//services
import { getWalletData } from "../../services/Wallet/getWalletData";
import { getWalletDashboard } from "../../services/Wallet/getWalletDashboard";
//utils
import { formatCurrency } from "../../utils/formatCurrency";
//context
import { useAppContext } from "../../context/AppContext";
import { useContextWallet } from "./WalletContext";
import { postRequestWithdraw } from "../../services/Wallet/postRequestWithdraw";
import { confirmDialog } from "primereact/confirmdialog";

const Wallet = () => {
  const { permissions } = useAppContext();
  const {
    formattedAccountData,
    setFormattedAccountData,
    accounts,
    setAccounts,
    isDataLoading,
    setIsDataLoading
  } = useContextWallet(false);

  const menu = useRef(null);
  const navigate = useNavigate();

  const form = useForm();
  const errors = form.formState.errors;

  const [checkedBalance, setCheckedBalance] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [selectedAccount, setSelectedAccount] = useState(0);
  const [checkedCash, setCheckedCash] = useState(false);
  const [dashboardData, setDashboardData] = useState(false);
  const [loadingWithdraw, setLoadingWithdraw] = useState(false);


  const { data: dashboardFirstData, isLoading: isLoadingDash } = useQuery(
    "blocks",
    () => getWalletDashboard(),
    {
      retry: false,
    }
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (
      dashboardFirstData &&
      dashboardFirstData.currentAccount &&
      !dashboardFirstData.error &&
      !formattedAccountData
    ) {
      console.log("UseEffect 1");

      setDashboardData(dashboardFirstData);
      const accs = dashboardFirstData.currentAccount.map((acc) => ({
        label: `Conta: ${acc.account_number}-${acc.account_digit}`,
        value: `${acc.id}`,
        command: () => changeAcc(acc.id),
      }));
      setAccounts(accs);
      const foundObject = dashboardFirstData.currentAccount.find(
        (item) => item.id === selectedAccount
      );

      const currentAcc = foundObject
        ? foundObject
        : dashboardFirstData.currentAccount[0];
      setSelectedAccount(currentAcc);
      console.log("currentAcc.token_lt,", currentAcc.token_lt)
      setFormattedAccountData({
        id: currentAcc.id,
        agency: `${currentAcc.agency}-${currentAcc.agency_digit}`,
        account: `${currentAcc.account_number}-${currentAcc.account_digit}`,
        availableBalance: dashboardFirstData.balance.error
          ? false
          : dashboardFirstData.balance,
        availableCashback: dashboardFirstData.cashback.error
          ? false
          : dashboardFirstData.cashback,
        token_lt: currentAcc.token_lt,
        accountNumber: currentAcc.account_number,
      });
    }
  }, [dashboardFirstData]);
  // eslint-disable-next-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (dashboardData && !dashboardData.error && !formattedAccountData) {
      console.log("UseEffect 2");
      const foundObject = dashboardFirstData.currentAccount.find(
        (item) => item.id === selectedAccount
      );
      const currentAcc = foundObject
        ? foundObject
        : dashboardFirstData.currentAccount[0];
      setSelectedAccount(currentAcc);
      setFormattedAccountData({
        id: currentAcc.id,
        agency: `${currentAcc.agency}-${currentAcc.agency_digit}`,
        account: `${currentAcc.account_number}-${currentAcc.account_digit}`,
        accountNumber: currentAcc.account_number,
        token_lt: currentAcc.token_lt,
      });
    }
  }, [dashboardData]);

  const itemsBread = [
    {
      template: () => (
        <Link to={"/wallet/dashboard"} className="p-breadcrumb-link">
          Wallet
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const CardIcon = ({ title, icon, action }) => {
    return (
      <div
        className="col-xl-2 col-md-4 text-center card-animation my-2"
        onClick={action}
      >
        <Panel mainCss="text-center">
          <div className="bg-success fa-2xl text-white rounded-circle p-4 d-inline-block mt-4">
            {icon}
          </div>
          <div className="pt-2">
            <p className="fw-bold">{title}</p>
          </div>
        </Panel>
      </div>
    );
  };

  const clickBalance = (e) => {
    setCheckedBalance(e);
    setCheckedCash(false);
  };

  const clickCash = (e) => {
    setCheckedCash(e);
    setCheckedBalance(false);
  };

  const changeAcc = async (id) => {
    console.log(id);
    setIsDataLoading(true);
    const foundObject = dashboardFirstData.currentAccount.find(
      (item) => item.id === id
    );
    const currentAcc = foundObject
      ? foundObject
      : dashboardFirstData.currentAccount[0];

    setSelectedAccount(currentAcc);
    setFormattedAccountData({
      id: currentAcc.id,
      agency: `${currentAcc.agency}-${currentAcc.agency_digit}`,
      account: `${currentAcc.account_number}-${currentAcc.account_digit}`,
    });

    const response = await getWalletData(id);
    //    console.log(response);

    setFormattedAccountData((prevState) => ({
      ...prevState,
      availableBalance: response.balance.error ? false : response.balance,
      availableCashback: response.cashback.error ? false : response.cashback,
      token_lt: response.currentAccount.token_lt,
    }));
    setIsDataLoading(false);
  };

  const handleWithdrawal = async (data) => {
    setLoadingWithdraw(true);
    const notificationId = toast.loading("Solicitando saque...");
    try {
      const sendData = {
        amount: data.withdrawalValue,
        currentAccount: formattedAccountData.id
      };
      const response = await postRequestWithdraw(sendData);

      toast.update(notificationId, {
        render: "Saque solicitado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
      form.reset();

      if (response && response?.success) {
        setFormattedAccountData((prevState) => ({
          ...prevState,
          availableBalance: parseFloat(formattedAccountData.availableBalance).toFixed(2) - parseFloat(data.withdrawalValue).toFixed(2),
        }));
      } else if (response && response?.error) {
        toast.update(notificationId, {
          render: response.error.message,
          type: "error",
          isLoading: false,
          autoClose: 4000,
        });
      } else {
        const updated = await getWalletData(selectedAccount.id || selectedAccount);
        setFormattedAccountData((prevState) => ({
          ...prevState,
          availableBalance: updated.balance.error ? false : updated.balance,
          availableCashback: updated.cashback.error ? false : updated.cashback,
          token_lt: updated.currentAccount.token_lt,
        }));
      }
    } catch (error) {
      console.log("Error requesting withdrawal:", error);
      if (
        error.response.data.error &&
        error.response.data.error.message === "Contrato não assinado. Solicitação de saque não permitida."
      ) {
        toast.dismiss(notificationId);
        confirmDialog({
          message: (
            <>
              Você precisa assinar o contrato para solicitar o saque.<br />
              A assinatura do contrato é obrigatória para garantir a segurança <br />
              e o correto processamento da solicitação.
            </>
          ),
          header: "Assinatura do Contrato Necessária",
          icon: "pi pi-exclamation-triangle",
          acceptLabel: "Entendi",
          rejectLabel: "Fechar",
          accept: () => {
            toast.info("Por favor, realize a assinatura do contrato para continuar.");
          },
          reject: () => {
            toast.warn("Saque não permitido sem a assinatura do contrato.");
          },
        });
        setLoadingWithdraw(false);
        return;
      }

      toast.update(notificationId, {
        render: "Erro ao solicitar saque, tente novamente mais tarde.",
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });
      console.error("Error requesting withdrawal:", error);
    } finally {
      setLoadingWithdraw(false);
    }
  }

  return (
    <>
      <div>
        <BreadCrumb
          model={itemsBread}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      {isLoadingDash && (
        <>
          <div className="row">
            <div className="col-md-4 my-2">
              <Skeleton width="100%" height="115px"></Skeleton>
            </div>
            <div className="col-md-8 my-2">
              <Skeleton width="100%" height="115px"></Skeleton>
            </div>
          </div>

          <div className="row pt-4">
            {Array.from({ length: 3 }).map(() => (
              <div className="col-md-4 my-2">
                <Skeleton width="100%" height="200px"></Skeleton>
              </div>
            ))}

            <div className="my-3">
              <div className="row">
                {Array.from({ length: 6 }).map(() => (
                  <div className="col-md-2 text-center card-animation my-2">
                    <Skeleton width="100%" height="160px"></Skeleton>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-8 my-2">
              <Skeleton width="100%" height="210px"></Skeleton>
            </div>
            <div className="col-md-4 my-2">
              <Skeleton width="100%" height="210px"></Skeleton>
            </div>
          </div>
        </>
      )}
      {!isLoadingDash && dashboardFirstData && !dashboardFirstData.error ? (
        <>
          <div className="row">
            <Tooltip
              target=".custom-choose-btn"
              content="Escolha uma conta para visualizar"
              position="bottom"
            />
            <div className="col-xl-4 col-md-6 my-2">
              <Panel mainCss="h-100">
                <div className="d-flex justify-content-between">
                  <div className="mt-1">
                    <h4>
                      Conta Atual{" "}
                      <i className="custom-choose-btn fa-solid text-success fa-circle-exclamation"></i>{" "}
                    </h4>
                    <h1 className="mb-0">
                      <b>{formattedAccountData.account}</b>
                    </h1>
                  </div>
                  <div>
                    <div>
                      <TieredMenu
                        model={accounts}
                        popup
                        ref={menu}
                        breakpoint="767px"
                      />
                      <Button
                        text
                        rounded
                        outlined
                        icon="pi pi-bars"
                        // style={{ color: "white" }}
                        onClick={(e) => menu.current.toggle(e)}
                      // nameLand={nameLand}
                      />
                    </div>
                    {/* <i className="fa-solid fa-arrow-right-arrow-left fa-2xl"></i> */}
                  </div>
                </div>
                <hr />
                <div>
                  <div className="d-flex justify-content-between">
                    <p className="fw-bold">
                      Agência:{" "}
                      <span className="text-gray">
                        {formattedAccountData.agency}
                      </span>{" "}
                    </p>
                    <p className="fw-bold">
                      Conta:{" "}
                      <span className="text-gray">
                        {formattedAccountData.account}
                      </span>{" "}
                    </p>
                    <p className="fw-bold">
                      Banco: <span className="text-gray">IB3 Capital</span>{" "}
                    </p>
                  </div>
                </div>
              </Panel>
            </div>
            <div className="col-xl-8 col-md-6 my-2">
              <Panel mainCss="h-100 bg-cyan-300 bg-opacity-75">
                <div className="row pt-4 justify-content-between">
                  <div className="col-xl-2 col-md-2 text-center">
                    <div className="bg-cyan rounded-circle p-4 d-inline-block">
                      <i className="fa-solid fa-2xl fa-mobile-screen-button"></i>
                    </div>
                  </div>

                  <div className="col-xl-10 col-md-9 mt-3">
                    <span className="text-blue-card">
                      <i className="bi bi-info-circle-fill me-1"></i>
                      <b>Atenção</b>: Realize pagamentos com a
                      <b> câmera </b>
                      do celular.
                    </span>
                    <h3 className="text-blue-card">
                      Baixe agora mesmo o APP IB3 
                    </h3>
                  </div>
                </div>
              </Panel>
            </div>
          </div>

          <div className="row pt-4">
            {isDataLoading ? (
              <>
                {Array.from({ length: 3 }).map(() => (
                  <div className="col-md-4 my-2">
                    <Skeleton width="100%" height="200px"></Skeleton>
                  </div>
                ))}

                <div className="my-3">
                  <div className="row">
                    {Array.from({ length: 6 }).map(() => (
                      <div className="col-md-2 text-center card-animation my-2">
                        <Skeleton width="100%" height="160px"></Skeleton>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-md-8 my-2">
                  <Skeleton width="100%" height="210px"></Skeleton>
                </div>
                <div className="col-md-4 my-2">
                  <Skeleton width="100%" height="210px"></Skeleton>
                </div>
              </>
            ) : (
              <>
                {formattedAccountData && (
                  <>
                    <div className="col-xl-4 col-md-6 my-2">
                      <Panel mainCss="h-100">
                        <div className="d-flex justify-content-between">
                          <small className="bg-success rounded-pill text-white p-2">
                            Conta Corrente
                          </small>
                          <p className="my-auto">
                            <i className="fa-solid fa-circle-dollar-to-slot fa-2xl text-success"></i>
                          </p>
                        </div>
                        <div className="py-4">
                          <span className="text-gray">Saldo disponível</span>
                          <h1>
                            {formatCurrency(
                              formattedAccountData.availableBalance
                            )}
                          </h1>
                        </div>
                      </Panel>
                    </div>
                    <div className="col-xl-4 col-md-6 my-2">
                      <Panel mainCss="h-100">
                        <div className="d-flex justify-content-between">
                          <small className="bg-success rounded-pill text-white p-2">
                            Conta Corrente Futuros
                          </small>
                          <p className="my-auto">
                            <i className="fa-solid fa-circle-dollar-to-slot fa-2xl text-success"></i>
                          </p>
                        </div>
                        <div className="py-4">
                          <span className="text-gray">Saldo futuro</span>
                          <h1>R$ 0,00</h1>
                        </div>
                      </Panel>
                    </div>
                    <div className="col-xl-4 col-md-12 my-2">
                      <CreditCard />
                    </div>

                    <div className="my-2">
                      <div className="row">
                        <div className="col-xl-8 my-2">
                          <Panel title="Solicitação de saque" mainCss="h-100 px-1">
                            {/* <div className="mt-1">
                                <ToggleButton
                                  onLabel="Saldo"
                                  offLabel="Saldo"
                                  checked={checkedBalance}
                                  onChange={(e) => clickBalance(e.value)}
                                  className="w-9rem py-2 rounded-pill me-2"
                                /> 
                                <ToggleButton
                                  onLabel="Cashback"
                                  offLabel="Cashback"
                                  checked={checkedCash}
                                  onChange={(e) => clickCash(e.value)}
                                  className="w-9rem py-2 rounded-pill"
                                /> 
                              </div> */}
                            <div className="row mt-1">
                              <div className="col-md-9">
                                <NumberInput
                                  name="withdrawalValue"
                                  mode="currency"
                                  currency="BRL"
                                  locale="pt-BR"
                                  useGrouping={true}
                                  placeholder={"R$ 0,00"}
                                  minFractionDigits={2}
                                  maxFractionDigits={2}
                                  control={form.control}
                                  errors={errors}
                                  label="Valor do Saque"
                                />
                              </div>
                              <div className="col-md-3 mt-3">
                                <Button
                                  label="Solicitar"
                                  icon="fa-regular fa-paper-plane"
                                  onClick={form.handleSubmit(handleWithdrawal)}
                                   disabled={
                                    loadingWithdraw ||
                                    parseFloat(formattedAccountData.availableBalance) <= 0 ||
                                    // Desabilita se valor digitado for maior que o saldo disponível
                                    (() => {
                                      const value = form.watch("withdrawalValue");
                                      if (!value) return false;
                                      const numericValue = typeof value === "string" ? parseFloat(value.replace(/[^\d,.-]/g, '').replace(',', '.')) : value;
                                      return numericValue > parseFloat(formattedAccountData.availableBalance);
                                    })()
                                  }
                                  // disabled={(parseFloat(formattedAccountData.availableBalance) <= 0) || loadingWithdraw}
                                  loading={loadingWithdraw}
                                />
                              </div>
                              <div className="mt-3 text-end d-flex justify-content-end">
                                <div className="col-md-2 me-4"></div>
                              </div>
                            </div>
                          </Panel>
                        </div>
                        <CardIcon
                          title="Extrato"
                          action={() =>
                            navigate("/wallet/extract", {
                              state: {
                                token_lt: formattedAccountData.token_lt,
                              },
                            })
                          }
                          icon={<i className="fa-regular fa-paste"></i>}
                        />
                        <CardIcon
                          title="IB Cash"
                          icon={<i className="fa-solid fa-sack-dollar"></i>}
                          // action={() => navigate(`/wallet/ibcash`)}
                          action={() => toast.warning("Funcionalidade em Desenvolvimento")}
                        />
                        {/* <CardIcon
                            title="Depositar"
                            icon={<i className="fa-regular fa-comments"></i>}
                            action={() =>
                              toast.warning(
                                "Este recurso está em desenvolvimento."
                              )
                            }
                          /> */}
                        {/* <CardIcon
                            title="Transferir"
                            icon={<i className="fa-regular fa-handshake"></i>}
                            action={() =>
                              toast.warning(
                                "Este recurso está em desenvolvimento."
                              )
                            }
                          /> */}
                        {/* <CardIcon
                            title="Cobrar"
                            icon={<i className="fa-regular fa-flag"></i>}
                            action={() =>
                              toast.warning(
                                "Este recurso está em desenvolvimento."
                              )
                            }
                          /> */}
                        {/* <CardIcon
                            title="Comprar"
                            icon={<i className="fa-solid fa-inbox"></i>}
                            action={() =>
                              toast.warning(
                                "Este recurso está em desenvolvimento."
                              )
                            }
                          /> */}
                      </div>
                    </div>
                    {/* <div className="col-md-8 my-2">
                        <Panel title="Solicitação de saque" mainCss="h-100 p-1">
                          <div className="mt-1">
                            <ToggleButton
                              onLabel="Saldo"
                              offLabel="Saldo"
                              checked={checkedBalance}
                              onChange={(e) => clickBalance(e.value)}
                              className="w-9rem py-2 rounded-pill me-2"
                            />
                            <ToggleButton
                              onLabel="Cashback"
                              offLabel="Cashback"
                              checked={checkedCash}
                              onChange={(e) => clickCash(e.value)}
                              className="w-9rem py-2 rounded-pill"
                            />
                          </div>
                          <div className="row mt-1">
                            <div className="col-md-9">
                              <NumberInput
                                name="value-loot"
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                useGrouping={true}
                                placeholder={0}
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                control={form.control}
                                errors={errors}
                                label="Valor do Saque"
                              />
                            </div>
                            <div className="col-md-3 mt-3">
                              <Button
                                label="Solicitar"
                                icon="fa-regular fa-paper-plane"
                              />
                            </div>
                            <div className="mt-3 text-end d-flex justify-content-end">
                              <div className="col-md-2 me-4"></div>
                            </div>
                          </div>
                        </Panel>
                      </div> */}
                    {/* <div className="col-md-4 my-2">
                        <Panel mainCss="h-100">
                          <div className="d-flex justify-content-between mt-3">
                            <h4>Cotação do Cashback</h4>
                            <p className="my-auto">
                              <i className="fa-solid fa-circle-dollar-to-slot fa-2xl text-success"></i>
                            </p>
                          </div>
                          <div className="row pt-3 justify-content-between">
                            <div className="col-md-6 text-center">
                              <p>Saldo em R$</p>
                              <h3>R$ 0,00</h3>
                            </div>
                            <div className="col-md-6 text-center">
                              <p>Cashback</p>
                              <h3>
                                IBC {formattedAccountData.availableCashback}
                              </h3>
                            </div>
                          </div>
                          <hr />
                          <div className="text-center">
                            <span className="text-gray">
                              Atualizado em 27/12/2023 - 16:30:21
                            </span>
                          </div>
                        </Panel>
                      </div> */}
                  </>
                )}
              </>
            )}
          </div>
        </>
      ) : (
        !isLoadingDash && (
          <div className="row">
            <div className="col-md-12 my-2">
              <Panel mainCss="h-100 bg-cyan-300 bg-opacity-75">
                <div className="row pt-4 justify-content-center">
                  <div className="col-md-2 text-center pt-2">
                    <div className="bg-cyan rounded-circle p-4 d-inline-block">
                      <i className="fa-solid fa-2xl fa-mobile-screen-button"></i>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <h3 className="text-blue-card">
                      Baixe agora mesmo o APP IB3 Capital
                    </h3>
                    <p className="text-blue-card">
                      <i className="bi bi-info-circle-fill me-1"></i>
                      <b>Atenção</b>: Parece que você não tem nenhuma conta IB3
                      cadastrada, acesse a homologação bancária e homologue sua
                      conta IB3 em menos de UM MINUTO. Caso não tenha uma conta
                      para homologar fale agora com seu consultor comercial e
                      não fique de fora das vantagens da carteira IB3 Capital!
                    </p>
                  </div>
                </div>
              </Panel>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default Wallet;
